/*
  FAQ-Akkordeon – ein gemeinsames Skript für Produktseiten und Blog.

  Container:
    .description_faq        Produktbeschreibung (sections/rich-text-PDP.liquid)
    .prose section.faq      Blogartikel

  Markup im Editor:
    #faq                    eigener Absatz (nackter Text oder in <p>/<strong>/<span>)
    Überschrift h2–h6       = Frage (Ebene der ersten Frage; sind H6-Fragen vorhanden, gilt H6)
    alles bis zur nächsten Frage = Antwort (mehrere Absätze, Listen, Links)

  Der Block endet – wie im Schema (snippets/faq-schema.liquid) – bei einer Überschrift anderer Ebene
  sowie bei <table>, <iframe>, <hr>, <img>, <video>.

  Klassennamen (.faq-item, .faq-question, .faq-label, .faq-answer, .active) bleiben bewusst gleich:
  das Inhaltsverzeichnis in sections/main-article.liquid liest die Fragen daraus.
*/
(function () {
  'use strict';

  // Das Skript wird von mehreren Sections eingebunden – nur einmal ausführen
  if (window.__sinobFaqAccordion) return;
  window.__sinobFaqAccordion = true;

  var SELECTOR = '.description_faq, .prose section.faq';
  var STOP_TAGS = /^(TABLE|IFRAME|HR|IMG|VIDEO)$/;
  var STOP_INNER = 'table, iframe, hr, img, video';
  var ICON =
    '<svg width="12" height="9" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false">' +
    '<path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path></svg>';
  // <details>-Akkordeons der FAQ-Sections (metaobject-FAQs) – gemeinsames Verhalten: immer nur eine Antwort offen
  var DETAILS = ':is(.shopify-section--faq, .gains_taste_faq, .influencer_2025_faq) details.accordion.item';
  var counter = 0;

  function isHeading(el) {
    return el.nodeType === 1 && /^H[1-6]$/.test(el.tagName);
  }

  function isMarker(node) {
    var text = (node.textContent || '').replace(/ /g, ' ').trim().toLowerCase();
    if (text !== '#faq') return false;
    if (node.nodeType === 3) return true;
    return node.nodeType === 1 && !isHeading(node) && !node.querySelector('h1,h2,h3,h4,h5,h6');
  }

  function hasContent(nodes) {
    return nodes.some(function (n) {
      if (n.nodeType === 3) return n.textContent.trim() !== '';
      return n.nodeType === 1;
    });
  }

  function introNode() {
    var strong = document.createElement('strong');
    strong.innerHTML =
      '<br><span style="font-size: var(--text-h2); font-family: var(--heading-font-family);">FAQ</span><br>' +
      '<span>Du hast Fragen? Kein Problem! Hier findest du die Antworten, die wir am häufigsten gestellt bekommen.</span>';
    return strong;
  }

  function setOpen(button, open) {
    var answer = button.nextElementSibling;
    button.classList.toggle('active', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) answer.style.maxHeight = open ? answer.scrollHeight + 'px' : '';
  }

  function build(container) {
    if (container.getAttribute('data-faq-ready') === 'true') return;
    container.setAttribute('data-faq-ready', 'true');

    var isProduct = container.classList.contains('description_faq');
    var kids = Array.prototype.slice.call(container.childNodes);

    // Marker #faq suchen; ohne Marker beginnt der FAQ-Bereich am Anfang des Containers (Blog)
    var start = 0;
    var marker = null;
    for (var i = 0; i < kids.length; i++) {
      if (isMarker(kids[i])) {
        marker = kids[i];
        start = i + 1;
        break;
      }
    }

    var scope = kids.slice(start);

    // Ebene der Fragen: H6, wenn vorhanden – sonst die erste Überschrift h2–h6
    var level = 0;
    var hasH6 = scope.some(function (n) { return n.nodeType === 1 && n.tagName === 'H6'; });
    if (hasH6) {
      level = 6;
    } else {
      for (var j = 0; j < scope.length; j++) {
        if (isHeading(scope[j]) && scope[j].tagName !== 'H1') {
          level = parseInt(scope[j].tagName.charAt(1), 10);
          break;
        }
      }
    }

    // Fragen und Antworten einsammeln
    var items = [];
    var current = null;
    if (level) {
      for (var k = 0; k < scope.length; k++) {
        var node = scope[k];
        if (node.nodeType === 1) {
          if (isHeading(node)) {
            if (parseInt(node.tagName.charAt(1), 10) === level) {
              current = { q: node, a: [] };
              items.push(current);
              continue;
            }
            // Überschrift vor der ersten Frage (z. B. <h2>FAQ</h2> hinter #faq) bleibt stehen
            if (!current) continue;
            break;
          }
          if (STOP_TAGS.test(node.tagName) || node.querySelector(STOP_INNER)) break;
        }
        if (current && !(node.nodeType === 3 && node.textContent.trim() === '')) current.a.push(node);
      }
    }

    // Marker ersetzen: Produktseite zeigt die FAQ-Überschrift, sonst wird er entfernt
    if (marker) {
      if (isProduct) {
        container.replaceChild(introNode(), marker);
      } else {
        container.removeChild(marker);
      }
    }

    var built = 0;
    items.forEach(function (item) {
      var questionText = item.q.textContent.replace(/\s+/g, ' ').trim();
      if (!questionText || !hasContent(item.a)) return;

      counter += 1;
      var buttonId = 'faq-q-' + counter;
      var answerId = 'faq-a-' + counter;

      var faqItem = document.createElement('div');
      faqItem.className = 'faq-item' + (built === 0 ? ' faq-first' : '');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'faq-question';
      button.id = buttonId;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', answerId);

      var label = document.createElement('span');
      label.className = 'faq-label';
      label.textContent = questionText;

      var icon = document.createElement('span');
      icon.className = 'faq-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = ICON;

      button.appendChild(label);
      button.appendChild(icon);

      var answer = document.createElement('div');
      answer.className = 'faq-answer';
      answer.id = answerId;
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-labelledby', buttonId);

      faqItem.appendChild(button);
      faqItem.appendChild(answer);

      container.insertBefore(faqItem, item.q);
      item.a.forEach(function (n) { answer.appendChild(n); });
      container.removeChild(item.q);
      built += 1;
    });

    if (!built) return;

    container.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('.faq-question') : null;
      if (!button || !container.contains(button)) return;
      setOpen(button, !button.classList.contains('active'));
    });
  }

  function recalcOpen() {
    document.querySelectorAll('.faq-question.active').forEach(function (button) {
      var answer = button.nextElementSibling;
      if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
    });
  }

  function closeOthers(except) {
    document.querySelectorAll('.faq-question.active').forEach(function (b) {
      if (b !== except) setOpen(b, false);
    });
    document.querySelectorAll(DETAILS).forEach(function (d) {
      if (d !== except && d.open) d.open = false;
    });
  }

  // Eine Antwort öffnen schließt alle anderen – über alle FAQ-Varianten der Seite
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.faq-question');
    if (button) {
      if (button.classList.contains('active')) closeOthers(button);
      return;
    }
    var summary = target.closest('details.accordion.item > summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (details.matches(DETAILS) && details.open) closeOthers(details);
  });

  function init() {
    document.querySelectorAll(SELECTOR).forEach(build);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(recalcOpen, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
